import { OwnListService } from './../own-list.service';
import { Component, OnInit, ViewChild, AfterViewInit, ElementRef, HostListener } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { Global } from '../classes/Global';
import { UrlValidator } from '../helpers/UrlValidater';
import { GenresService } from '../genres.service';
import { OffersParentComponent } from '../classes/OffersParentComponent';
import { InfoService } from '../info.service';
import { WishlistService } from '../wishlist.service';
import { AuthenticationService } from '../authentication.service';
import { StorageHelper } from '../helpers/StorageHelper';
import { ModalComponent } from '../modal/modal.component';
import { BaseService } from '../classes/BaseService';
import { Log } from '../helpers/Log';
import { SettingsService } from '../settings.service';
import { ThemeService } from '../theme.service';
import { SeoService } from '../seo.service';
import { BlocklistService } from '../blocklist.service';
import { ListHelper } from '../helpers/ListHelper';
import { BrowserNavigationHelper } from '../helpers/BrowserNavigationHelper';

@Component({
  selector: 'app-my-purchases',
  templateUrl: './my-purchases.component.html',
  styleUrls: ['./my-purchases.component.scss'],
  providers: [ OwnListService, GenresService, InfoService,
    WishlistService, AuthenticationService ]
})
export class MyPurchasesComponent extends OffersParentComponent implements OnInit, AfterViewInit {

  itemToRemove = null;
  searchTerm = "";
  get itemCount(): number {
    return this.items ? this.items.length : 0;
  }
  @ViewChild("confirmRemoveFromOwnListModal", {static: false}) confirmRemoveFromOwnListModal;
  @ViewChild("authentication", {static: false}) authentication;
  @ViewChild("importiTunesLibraryModal", { static: false }) importiTunesLibraryModal;
  @ViewChild("importVuduLibraryModal", { static: false }) importVuduLibraryModal;
  @ViewChild('importWarning', {static: false}) importWarning;
  @ViewChild('exportDDContent', { static: false }) exportDDContent: ElementRef;

  @HostListener('document:click', ['$event'])
  clickout(event) {
    if (!event || !event.target) {
      return;
    }
    try {
      const targetElement = event.target as HTMLElement;
      let clickedInsideDropdown = false;
      try {
        clickedInsideDropdown = targetElement && targetElement.closest && targetElement.closest('.dropdown') !== null;
      } catch (e) {
        // Permission denied when accessing closest() from cross-origin iframe - ignore
        return;
      }
      if (!clickedInsideDropdown) {
        if (this.exportDDContent) {
          this.closeDropdown(this.exportDDContent);
        }
      }
    } catch (e) {
      // Ignore permission errors from cross-origin iframes or restricted contexts
    }
  }

  constructor(
    protected route: ActivatedRoute,
    protected router: Router,
    protected genresService: GenresService,
    protected infoService: InfoService,
    protected wishlistService: WishlistService,
    protected blocklistService: BlocklistService,
    protected authenticationService: AuthenticationService,
    protected ownListService: OwnListService,
    protected settingsService: SettingsService,
    protected themeService: ThemeService,
    protected seoService: SeoService
  ) {
    super(genresService, router, route, authenticationService, infoService, wishlistService, blocklistService, ownListService, settingsService, themeService, seoService);
    this.cacheResults = false;
    this.identifier = Global.MY_PURCHASES;
    this.limit = 72;
  }

  initSorting() {
    this.sortValues = this.getSortingValues();
    if (this.sortValues.indexOf(this.getSort('ownlist')) > -1) {
      this.sortKey = this.getSort('ownlist');
    } else {
      this.sortKey = this.sortValues[0];
    }
  }

  ngOnInit() {
    UrlValidator.validateUrl(this.route, this.router, Global.MY_PURCHASES, this);
    this.getSessionTokenFromUrl();
    super.onInit();
    this.loadGenreAndItems();
  }

  ngAfterViewInit() {
    this.setScrollPosition();
  }

  //overriding parent method
  getMediaType() {
    return Global.getMediaTypeForWishlistRequest();
  }

  qualityOptionsHook(qualities: Array<any>): Array<any> {
    qualities.unshift({title: this.getString("all"), type: "all"});
    return qualities;
  }

  getOffers() {

    this.searchTerm = "";
    return this.ownListService.getDetailItemList(StorageHelper.getInstance().get(StorageHelper.keys.sessionToken),
    Global.getStore(), Global.getMediaTypeForWishlistRequest(), Global.getCountry(),
    this.formatMultiSelectionForServer(this.selectedGenres, this.genres),
      this.getQuality(), this.sortKey, this.offset, this.limit);
  }

  reload(newUrl: boolean = false, replaceUrl?: boolean) {
    let mediaType = Global.getMediaType();
    if(mediaType == Global.BUYMOVIES || mediaType == Global.RENTALMOVIES) {
      mediaType = Global.MOVIES;
    }
    if(mediaType == Global.ALBUMS || mediaType == Global.SINGLES) {
      mediaType = Global.MUSIC;
    }
    const url = Global.getCountry() + '/' + Global.getStoreUrl() + '/' + this.getString(mediaType + "Url") + '/' + this.getString('myPurchasesUrl');
    const targetUrl = "/" + url;
    // Only navigate if URL actually changed to prevent excessive replaceState calls
    if (this.router.url !== targetUrl) {
      if (replaceUrl === true) {
        this.router.navigate([url], { replaceUrl: true }).then(_ => this.loadGenreAndItems());
      } else {
        this.router.navigate([url]).then(_ => this.loadGenreAndItems());
      }
    } else {
      this.loadGenreAndItems();
    }
  }

  getSortingValues() {
    return [
      Global.ADDED_TO_OWNLIST_AT,
      Global.ALPHABETICAL
    ];
  }

  getHeaderTitle(): string {
    return this.getString('myPurchasesHeaderTitle');
  }

  getHeaderText(): string {
    return this.getString('myPurchasesHeaderText');
  }

  searchClicked(obj: any) {
    this.searchTerm = obj.query;
    this.search();
  }

  search() {
    this.ownListService.search(Global.getCountry(), Global.getStore(),
    Global.getMediaTypeForWishlistRequest(), this.searchTerm,
    StorageHelper.getInstance().get(StorageHelper.keys.sessionToken)).subscribe((res: any) => {
      if (res && res.results) {
        this.items = res.results[Global.getMediaTypeForWishlistRequest()] || [];
      }
    });
  }

  cancelSearch(){
    this.searchTerm = "";
    this.reload(false);
  }

  removeFromOwnlistClicked(item) {
    this.itemToRemove = item;
    this.confirmRemoveFromOwnListModal.open();
  }

  onConfirmRemoveFromOwnlistModalResult(result) {
    if (result === ModalComponent.RESULT_YES) {
      this.removeFromOwnlist(this.itemToRemove);
    }
    else {
      this.itemToRemove = null;
    }
  }
  removeFromOwnlist(item) {
    this.itemToRemove = null;
    const sessionToken = StorageHelper.getInstance().get(StorageHelper.keys.sessionToken);
      if (sessionToken){

      let pluralItemType = Global.getPluralItemType(item.itemType);
      if (pluralItemType) {

        if (pluralItemType === "movies") { pluralItemType = "buymovies"; } //Cool Cool API

        const id = item.idInStore || item.itemID;

        this.ownlistService.removeItem(Global.getCountry(), Global.getStore(), pluralItemType,
          sessionToken, item.idInStore)
          .subscribe(res => {

            if (res && res["message"] == BaseService.COULDNT_LOAD_USER) {
              StorageHelper.getInstance().clear(StorageHelper.keys.sessionToken);
              this.authentication.openLogin();
            }
            else {
              //Success!
              this.updateLocalShortOwnlist(sessionToken);
              if (this.searchTerm) {
                this.search();
              }
              else {
                this.reload(false);
              }
            }

          }, err => {
            Log.getInstance().d(err);
            this.updateLocalShortOwnlist(sessionToken);
          });
        }
      }
  }

  updateLocalShortOwnlist(sessionToken: string) {
    this.ownlistService.getShortItemList(
      sessionToken,
      Global.getStore(),
      Global.getCountry()
    ).subscribe(res => {

      if (res && res["message"] === BaseService.COULDNT_LOAD_USER) {
        StorageHelper.getInstance().clear(StorageHelper.keys.sessionToken);
        this.authentication.openLogin();
      }
      else if (res && res["results"]) {
        const shortOwnlist = StorageHelper.getInstance().get(StorageHelper.keys.shortOwnlist) || {};
        shortOwnlist[Global.getStore()] = res["results"];
        const saved = StorageHelper.getInstance().save(StorageHelper.keys.shortOwnlist, shortOwnlist);
        if (saved) {
          ListHelper.clearOwnlistCache();
        } else {
          Log.getInstance().d('Failed to save ownlist to storage - storage may be full');
        }
      }
    },
    err => {
      Log.getInstance().d(err);
    });
  }

  importiTunesLibrary() {
    if(this.storeIsItunes()) {
      this.importiTunesLibraryModal.open();
    } else {
      this.importWarning.open();
    }
  }

  importVuduLibrary() {
    if(this.storeIsVudu()) {
      this.importVuduLibraryModal.open();
    } else {
      this.importWarning.open();
    }
  }

  storeIsItunes(): boolean {
    return Global.getStore() === Global.ITUNES;
  }

  storeIsVudu(): boolean {
    return Global.getStore() === Global.VUDU;
  }

  isMoviesOrTv(): boolean {
    const media = this.getMedia(); // getMedia already returns getString(Global.getMediaTypeForWishlistRequest())
    // Since getMedia returns translated strings, we should check against the keys or ensure getMedia returns what we expect.
    // Let's check the raw media type instead for safety.
    const rawMedia = Global.getMediaTypeForWishlistRequest();
    return rawMedia === Global.MOVIES || rawMedia === Global.SEASONS || rawMedia === Global.TV;
  }

  showImportButton(): boolean {
    return (this.storeIsItunes() || this.storeIsVudu()) && this.isMoviesOrTv();
  }

  showItunesImport(): boolean {
    return this.storeIsItunes() && this.isMoviesOrTv();
  }

  showVuduImport(): boolean {
    return this.storeIsVudu() && this.isMoviesOrTv();
  }

  getMedia(): string {
    return this.getString(Global.getMediaTypeForWishlistRequest());
  }

  showImportMacOSNewFeatureBubble() {
    return StorageHelper.getInstance().get(StorageHelper.keys.showImportMacOSNewFeatureBubble) == "false"? false : true;
  }

  closeImportMacOSNewFeatureBubble() {
    StorageHelper.getInstance().save(StorageHelper.keys.showImportMacOSNewFeatureBubble, "false");
  }

  // Override loadMoreItems to prevent infinite scroll during search
  loadMoreItems() {
    // Prevent loading more items when search is active
    if (this.searchTerm && this.searchTerm.trim() !== '') {
      return;
    }

    // Call parent implementation for normal loading
    super.loadMoreItems();
  }

  exportDropdownClicked() {
    if (this.exportDDContent && this.exportDDContent.nativeElement) {
      if (this.exportDDContent.nativeElement.classList.contains('dd-open')) {
        this.closeDropdown(this.exportDDContent);
      } else {
        this.openDropdown(this.exportDDContent);
      }
    }
  }

  isDropdownOpen(dropdownRef: ElementRef): boolean {
    return dropdownRef && dropdownRef.nativeElement && dropdownRef.nativeElement.classList.contains('dd-open');
  }

  closeDropdown(dropdownRef: ElementRef) {
    if (dropdownRef && dropdownRef.nativeElement) {
      dropdownRef.nativeElement.className = 'dropdown-content dd-right dd-close';
    }
  }

  openDropdown(dropdownRef: ElementRef) {
    if (dropdownRef && dropdownRef.nativeElement) {
      dropdownRef.nativeElement.className = 'dropdown-content dd-right dd-open';
    }
  }

  exportWithUrl() {
    // Close dropdown
    if (this.exportDDContent) {
      this.closeDropdown(this.exportDDContent);
    }

    const sessionToken = StorageHelper.getInstance().get(StorageHelper.keys.sessionToken);
    if (!sessionToken) {
      Log.getInstance().d('No session token available for export');
      return;
    }

    const country = Global.getCountry();
    const store = Global.getStore();
    const mediaType = Global.getMediaTypeForWishlistRequest();

    const shareTab = BrowserNavigationHelper.openBlankTabForAsyncResult();

    this.ownListService.getShareOwnListUrl(country, store, mediaType, sessionToken)
      .subscribe(res => {
        if (res && res.status === 'success' && res.additionalInfo && res.additionalInfo.shareURL) {
          const shareURL = res.additionalInfo.shareURL;
          BrowserNavigationHelper.navigateOpenedTabOrSameWindow(shareTab, shareURL);
        } else {
          BrowserNavigationHelper.closeTabIfOpen(shareTab);
          Log.getInstance().d('Failed to get share URL: ' + JSON.stringify(res));
        }
      }, err => {
        BrowserNavigationHelper.closeTabIfOpen(shareTab);
        Log.getInstance().d('Error getting share URL: ' + err);
      });
  }

  exportToCsv() {
    // Close dropdown
    if (this.exportDDContent) {
      this.closeDropdown(this.exportDDContent);
    }

    const sessionToken = StorageHelper.getInstance().get(StorageHelper.keys.sessionToken);
    if (!sessionToken) {
      Log.getInstance().d('No session token available for export');
      return;
    }

    const country = Global.getCountry();
    const store = Global.getStore();
    const mediaType = Global.getMediaTypeForWishlistRequest();

    const shareTab = BrowserNavigationHelper.openBlankTabForAsyncResult();

    this.ownListService.getShareOwnListUrl(country, store, mediaType, sessionToken)
      .subscribe(res => {
        if (res && res.status === 'success' && res.additionalInfo && res.additionalInfo.shareURL) {
          let shareURL = res.additionalInfo.shareURL;
          // Append action=exportCSV to the URL
          const separator = shareURL.indexOf('?') > -1 ? '&' : '?';
          shareURL = shareURL + separator + 'action=exportCSV';
          BrowserNavigationHelper.navigateOpenedTabOrSameWindow(shareTab, shareURL);
        } else {
          BrowserNavigationHelper.closeTabIfOpen(shareTab);
          Log.getInstance().d('Failed to get share URL: ' + JSON.stringify(res));
        }
      }, err => {
        BrowserNavigationHelper.closeTabIfOpen(shareTab);
        Log.getInstance().d('Error getting share URL: ' + err);
      });
  }

}
